// Curated set of font families the app can actually render — they're
// self-hosted via @fontsource in `src/fonts.ts`, which is imported globally in
// `main.tsx`, so these render anywhere in the app without extra loading.
//
// Single source of truth shared by the video editor's text/brand font pickers
// and the brand typography editor in Configuración, so both offer exactly the
// same fonts. To add a font: import its @fontsource css in `src/fonts.ts` and
// add it here.

export type FontCategory = "sans" | "serif" | "display" | "handwriting" | "mono";

export const TEXT_FONT_OPTIONS: Array<{
  family: string;
  category: FontCategory;
  label?: string;
}> = [
  { family: "Inter", category: "sans" },
  { family: "Poppins", category: "sans" },
  { family: "Montserrat", category: "sans" },
  { family: "Roboto", category: "sans" },
  { family: "Playfair Display", category: "serif" },
  { family: "Bebas Neue", category: "display" },
  { family: "Oswald", category: "display" },
  { family: "Lobster", category: "handwriting" },
  { family: "Caveat", category: "handwriting" },
  { family: "Pacifico", category: "handwriting" },
  // Subtitle / viral-caption pack (TikTok / Reels / Shorts / MrBeast style).
  { family: "Anton", category: "display" },
  { family: "Fjalla One", category: "display" },
  { family: "Archivo Black", category: "display" },
  { family: "Russo One", category: "display" },
  { family: "Bangers", category: "display" },
  { family: "Luckiest Guy", category: "display" },
  { family: "Permanent Marker", category: "handwriting" },
];
